// extracted by mini-css-extract-plugin
export default {"adReport":"AdReport_adReport__ceP93","adReportTitle":"AdReport_adReportTitle__MBzd7"};